module.exports = __webpack_public_path__ + "static/media/logo-precidia-rentals.cca36f38.svg";